import React, { MouseEventHandler } from 'react';
import Avatar from '@mui/material/Avatar';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CheckCircleTwoToneIcon from '@mui/icons-material/CheckCircleTwoTone';
import CircleTwoToneIcon from '@mui/icons-material/CircleTwoTone';
import { LinkedRecord } from '../../shared/material_components/linked-cell';

interface Props {
  task: LinkedRecord,
  onClick?: (task: LinkedRecord) => void,
}

const subtext = (status: string|null, assignee: string|null): string => {
  if (!assignee) {
    const capitalize = (lowerStr: string) => lowerStr.charAt(0).toUpperCase() + lowerStr.slice(1);
    return status ? `${capitalize(status)}, unassigned` : 'Unassigned';
  }
  switch (status) {
    case 'open':
    case 'Open':
      return `Open, Assigned to ${assignee}`;
    case 'in progress':
    case 'In Progress':
      return `In Progress, Assigned to ${assignee}`;
    case 'complete':
    case 'Complete':
      return `Completed by ${assignee}`;
    default:
      return '';
  }
};

enum linkedStatusColor {
  'open' = 'info',
  'Open' = 'info',
  'in progress' = 'success',
  'In Progress' = 'success',
  'complete' = 'success',
  'Complete' = 'success',
  'default' = 'gray'
}

const statusIcon = (status: string|null) => {
  if (status === 'complete' || status === 'Complete') {
    return <CheckCircleTwoToneIcon color="success" />;
  }

  return <CircleTwoToneIcon color={linkedStatusColor[status || 'default']} />;
};

const TaskLink: React.FC<Props> = ({
  task,
  onClick = () => {},
}) => {
  const handleClick = (e: MouseEventHandler<HTMLLIElement>) => {
    // @ts-ignore
    e.preventDefault();
    onClick(task);
  };
  return (
    // @ts-ignore
    <ListItem onClick={handleClick} disablePadding>
      <ListItemButton sx={{ padding: '8px 0px' }}>
        <ListItemAvatar>
          { /* @ts-ignore */ }
          <Avatar alt={task.assigned_to} src={`/users/${task.assigned_to_id}/avatar`} />
        </ListItemAvatar>
        <ListItemText primary={task.form_values['4ae3']} secondary={subtext(task.status || '', task.assigned_to || '')} />
        <ListItemIcon sx={{ padding: '0px 0px 0px 20px', minWidth: 'unset' }}>
          {statusIcon(task.status || '')}
        </ListItemIcon>
      </ListItemButton>
    </ListItem>
  );
};

export default TaskLink;
